// Путь: D:\QR\QR-WEB\dashboard\src\components\User\BrandStore.jsx
// Название: Brand Store - список брендов пользователя с DARY Universal
// Версия: 2.0.0
// Дата: 27.01.2026

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BrandStore.css';

const API_URL = 'https://qr-money.onrender.com/api';
const DARY_BRAND_ID = 13;

const BrandStore = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalBrand, setTotalBrand] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    loadBrands();
  }, []);

  const loadBrands = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`${API_URL}/brand-store/my-balances`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        const withBalance = (data.data.balances || []).filter(b => parseFloat(b.amount) > 0);
        
        // Сортируем: DARY сверху, потом по балансу
        const sorted = withBalance.sort((a, b) => {
          if (a.brand_id === DARY_BRAND_ID) return -1;
          if (b.brand_id === DARY_BRAND_ID) return 1;
          return parseFloat(b.amount) - parseFloat(a.amount);
        });
        
        setBrands(sorted);
        setTotalBrand(parseFloat(data.data.totalBrandDar || 0));
      }
    } catch (err) {
      console.error('Load brands error:', err);
    } finally {
      setLoading(false);
    }
  };

  const getBrandColor = (brand) => {
    if (brand.brand_id === DARY_BRAND_ID) return '#8B5CF6';
    if (!brand.primary_color || brand.primary_color === '#000000' || brand.primary_color === '#111111') return '#6366F1';
    return brand.primary_color;
  };

  const isDaryBrand = (brand) => brand.brand_id === DARY_BRAND_ID;

  if (loading) {
    return <div className="bs-loading"><div className="bs-spinner"></div></div>;
  }

  return (
    <div className="bs-page">
      <div className="bs-header">
        <h1>🏪 Brand Store</h1>
        <div className="bs-total">
          Всего Brand DAR: <strong>{totalBrand.toFixed(2)}</strong>
        </div>
      </div>

      {brands.length === 0 ? (
        <div className="bs-empty">
          <div className="bs-empty-icon">🎁</div>
          <h3>У вас пока нет Brand балансов</h3>
          <p>Получите подарок от бренда, чтобы начать покупки</p>
          <button onClick={() => navigate('/vouchers/claim')} className="bs-btn">
            Активировать подарок
          </button>
        </div>
      ) : (
        <div className="bs-grid">
          {brands.map((brand) => (
            <div
              key={brand.brand_id}
              className={`bs-card ${isDaryBrand(brand) ? 'bs-card-dary' : ''}`}
              onClick={() => navigate(`/brand-store/${brand.brand_slug}`)}
            >
              <div
                className="bs-card-bar"
                style={{ backgroundColor: getBrandColor(brand) }}
              />
              
              {isDaryBrand(brand) && (
                <div className="bs-dary-badge">🎁 DARY Universal</div>
              )}
              
              <div className="bs-card-emoji">{brand.logo_emoji || '🎁'}</div>
              <div className="bs-card-name">{brand.brand_name}</div>
              <div className="bs-card-balance" style={{ color: getBrandColor(brand) }}>
                {parseFloat(brand.amount).toFixed(2)} DAR
              </div>
              <div className="bs-card-stats">
                <span>Получено: {parseFloat(brand.total_received).toFixed(2)}</span>
                <span>Потрачено: {parseFloat(brand.total_spent).toFixed(2)}</span>
              </div>
              
              {isDaryBrand(brand) ? (
                <button className="bs-card-btn bs-card-btn-dary">
                  🎁 Офферы DARY →
                </button>
              ) : (
                <button className="bs-card-btn">Перейти в магазин →</button>
              )}
            </div>
          ))}
        </div>
      )}

      <button onClick={() => navigate('/dashboard')} className="bs-back">
        ← Назад
      </button>
    </div>
  );
};

export default BrandStore;